// Angular Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';

// Tab Components
import { MatDivider } from '@angular/material/divider';
import { NavigationTabsComponent } from './components/navigation-tabs/navigation-tabs.component';

const angularModules = [CommonModule, RouterModule, MatTabsModule, MatDivider];
const externalComponents = [NavigationTabsComponent];

@NgModule({
  exports: [...externalComponents],
  imports: [...angularModules, ...externalComponents],
})
export class UITabsModule { }
